import React from 'react';
import { parseProps } from './@uteis';
import Checkbox from './Checkbox';
import ListItem from './ListItem';
import RadioButton from './RadioButton';

const SelectOption = (_props) => {
  const props = parseProps(_props);
  const attr = {};
  const classes = [];

  if (props.selected) {
    attr.selected = true;
    classes.push('selected');
  }
  if (props.active) {
    attr.active = true;
  }
  if (props.disabled) {
    attr.disabled = true;
  }

  const dataAll = 'data-all' in props ? 'true' : null;
  const highlighted = 'highlighted' in props ? 'true' : null;

  const option = 'multiple' in props ? (
    <Checkbox {...attr} label={props.children} />
  ) : (
    <RadioButton {...attr} label={props.children} />
  );

  return (
    <ListItem
      key={props.key}
      title={props.title}
      divider
      data-all={dataAll}
      highlighted={highlighted}
      classes={classes.join(' ')}
    >
      {option}
    </ListItem>
  );
};

export default SelectOption;
